var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-editor',{attrs:{"permission":'reference',"fields":_vm.fields,"endpoint":'reference',"updatePossible":true,"publication":"","reference":"","hasAuthor":false,"previewModule":"referenties","module":'reference'}})
}
var staticRenderFns = []

export { render, staticRenderFns }